import React, { useState, useEffect, useRef } from "react";
import Tab from "../../components/Tab";
import { AlertCircle, Info, Upload, User } from "react-feather";
import Dropdown from "../../components/input/Dropdown";
import {
  getBulkDropdownData,
  getDropdownData,
  getFieldValuesByTableAndId,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import Input from "../../components/input/Input";
import SearchDropdown from "../../components/input/SearchDropdown";
import LoadingSpinner from "../../components/LoadingSpinner";
import { getCompanies } from "../../api/companyApi";
import DocumentUpload from "../../components/DocumentUpload";
import Button from "../../components/input/Button";
import { useSelector } from "react-redux";
import { getNcrDetailByNcrId, ncrUpdate, ncrUpload } from "../../api/ncrApi";
import {
  addAndUpload,
  deleteDocumentList,
  getDocumentByOpeAndRef,
  updateAndUpload,
} from "../../api/documentUpload";
import { toast } from "react-toastify";
import { formatFromJsonDate, splitDateFromDateTime } from "../../dateConfig";
import { ncrFormValidator } from "../../components/validations/Ncr";
import { FORMS, MODULES } from "../../const";
import useUserCompany from "../../hooks/useUserCompany";
import useFirstAndLastAuthorizedTab from "../../hooks/useFirstAndLastAuthorizedTab";
import InfoList from "../../components/InfoList";
import Modal from "../../components/Modal";

const NCRCreate = ({
  editMode,
  reqCode,
  ncrid,
  ncrCode,
  reqId,
  handleDrawerClose,
}) => {
  const { firstViableTab, lastViableTab } = useFirstAndLastAuthorizedTab({
    module: MODULES.Transaction,
    section: FORMS.NCR,
  });
  // const [drawerTab, setDrawerTab] = useState(firstViableTab);
  const user = useSelector((state) => state.user);
  const [tab, setTab] = useState(firstViableTab);
  const userCompany = useUserCompany();
  const [ncrId, setNcrId] = useState(null);
  const [ncrCompany, setNcrCompany] = useState(null);
  const [ncrProjectName, setNcrProjectName] = useState("");
  const [ncrReportedBy, setNcrReportedBy] = useState("");
  const [ncrReportedDate, setNcrReportedDate] = useState(null);
  const [ncrCustomerComplaint, setNcrCustomerComplaint] = useState(null);
  const [ncrMadeVia, setNcrMadeVia] = useState(null);
  const [ncrType, setNcrType] = useState(null);
  const [ncrCustomer, setNcrCustomer] = useState(null);
  const [ncrCustomerName, setNcrCustomerName] = useState("");
  const [ncrEmail, setNcrEmail] = useState("");
  const [ncrPhone, setNcrPhone] = useState("");
  const [ncrSeverity, setNcrSeverity] = useState(null);
  const [ncrReportedConcern, setNcrReportedConcern] = useState("");
  const [ncrCause, setNcrCause] = useState("");
  const [ncrImmAction, setNcrImmAction] = useState("");
  const [ncrImmBy, setNcrImmBy] = useState("");
  const [ncrImmDate, setNcrImmDate] = useState("");
  const [ncrCorrAction, setNcrCorrAction] = useState("");
  const [ncrCorrBy, setNcrCorrBy] = useState("");
  const [ncrCorrDate, setNcrCorrDate] = useState("");
  const [ncrPrvAction, setNcrPreAction] = useState("");
  const [ncrPreBy, setNcrPreBy] = useState("");
  const [ncrPreDate, setNcrPreDate] = useState("");
  const [ncrFinalOutcome, setNcrFinalOutcome] = useState("");
  const [ncrFeedbackGiven, setNcrFeedbackGiven] = useState("");
  const [ncrFeedbackReevaluation, setNcrFeedbackReevaluation] = useState("");
  const [ncrReevaluationDate, setNcrReevaluationDate] = useState("");
  const [ncrCost, setNcrCost] = useState("");
  const [ncrStatus, setNcrStatus] = useState(2);
  const [ncrActive, setNcrActive] = useState(1);

  const [madeViaOptions, setMadeViaOptions] = useState([]);
  const [ncrTypeOptions, setNcrTypeOptions] = useState([]);
  const [customerComplaintOptions, setCustomerComplaintOptions] = useState([]);

  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [fileNameOptions, setFileNameOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [activeOptions, setActiveOptions] = useState([]);
  const [isDropdownLoading, setIsDropdownLoading] = useState(false);
  const documentRef = useRef();

  const [infoLoading, setInfoLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [currentErrors, setCurrentErrors] = useState({});
  const [isBlurred, setIsBlurred] = useState(false);
  const [initialActive, setInitialActive] = useState(1);

  const [company, setCompany] = useState(
    userCompany ? userCompany.comId : null,
  );

  const [auditInfo, setAuditInfo] = useState({});
  const deleteWarningRef = useRef();
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  const [pendingSubmit, setPendingSubmit] = useState(false);

  useEffect(() => {
    setCompany(userCompany ? userCompany.comId : null);
  }, [userCompany]);

  useEffect(() => {
    if (editMode) {
      const fetchData = async () => {
        setInfoLoading(true);
        setNcrId(ncrid);
        const ncrDetail = await getNcrDetailByNcrId(ncrid);
        console.log("ncrDetail", ncrDetail);
        setNcrCompany(ncrDetail.ncrCompany);
        setNcrProjectName(ncrDetail.ncrProjectName);
        setNcrReportedBy(ncrDetail.ncrReportedBy);
        setNcrReportedDate(splitDateFromDateTime(ncrDetail.ncrReportedDate));
        setNcrCustomerComplaint(ncrDetail.ncrCustomerComplaint);
        setNcrMadeVia(ncrDetail.ncrMadeVia);
        setNcrType(ncrDetail.ncrType);
        setNcrCustomer(ncrDetail.ncrCustomer);
        setNcrCustomerName(ncrDetail.ncrCustomerName);
        setNcrEmail(ncrDetail.ncrEmail);
        setNcrPhone(ncrDetail.ncrPhone);
        setNcrSeverity(ncrDetail.ncrSeverity);
        setNcrReportedConcern(ncrDetail.ncrConcernReported);
        setNcrCause(ncrDetail.ncrCause);
        setNcrImmAction(ncrDetail.ncrImmAction);
        setNcrImmBy(ncrDetail.ncrImmBy);
        setNcrImmDate(splitDateFromDateTime(ncrDetail.ncrImmDate));
        setNcrCorrAction(ncrDetail.ncrCorrAction);
        setNcrCorrBy(ncrDetail.ncrCorrBy);
        setNcrCorrDate(splitDateFromDateTime(ncrDetail.ncrCorrDate));
        setNcrPreAction(ncrDetail.ncrPreAction);
        setNcrPreBy(ncrDetail.ncrPreBy);
        setNcrPreDate(splitDateFromDateTime(ncrDetail.ncrPreDate));
        setNcrFinalOutcome(ncrDetail.ncrFinalOutcome);
        setNcrFeedbackGiven(ncrDetail.ncrFeedbackGiven);
        setNcrFeedbackReevaluation(ncrDetail.ncrFeedbackReevaluation);
        setNcrReevaluationDate(
          splitDateFromDateTime(ncrDetail.ncrReevaluationDate),
        );
        setNcrStatus(ncrDetail.ncrStatus);
        setNcrActive(ncrDetail.ncrActive);
        setInitialActive(ncrDetail.ncrActive);
        setNcrCost(ncrDetail.ncrCost);
        setAuditInfo({
          createdDate: ncrDetail.createdDate,
          createdBy: ncrDetail.createdBy,
          lastModifiedBy: ncrDetail.lastModifiedBy,
          lastModifiedDate: ncrDetail.lastModifiedDate,
        });

        const documents = await getDocumentByOpeAndRef(12, ncrid);
        setDocuments(documents);

        setInfoLoading(false);
      };
      fetchData();
    }
  }, [editMode, ncrid]);

  console.log("Ncr Reported date", ncrReportedDate);

  useEffect(() => {
    (async () => {
      setIsDropdownLoading(true);
      // const companies = await getCompanies();
      // setFrmCompanyOptions(companies);

      //new

      const {
        yesno: customerComplaint,
        ncr_made_via: madeVia,
        ncr_type: ncrType,
        doc_type: docTypeData,
        "file_name#12": fileNameData,
        status: statusData,
        active: activeData,
      } = await getBulkDropdownData([
        { key: "yesno" },
        { key: "ncr_made_via" },
        { key: "ncr_type" },
        { key: "doc_type" },
        { key: "file_name", group: "12" },
        { key: "status" },
        { key: "active" },
      ]);

      setCustomerComplaintOptions(customerComplaint);
      setMadeViaOptions(madeVia);
      setNcrTypeOptions(ncrType);
      setDocumentTypeOptions(docTypeData);
      setFileNameOptions(fileNameData);
      setStatusOptions(statusData);
      setActiveOptions(activeData);
      setIsDropdownLoading(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (ncrCustomer) {
        const customer = await getFieldValuesByTableAndId({
          tableName: "masterdata.tms_m_stakeholder",
          primaryKey: "stk_id",
          fieldNames: "stk_name,stk_code",
          ids: ncrCustomer,
        });
        console.log("customer", customer);
        setNcrCustomerName(customer[0].field1);
      }
    })();
  }, [ncrCustomer]);

  const submitNcr = async (bypassDeleteCheck = false) => {
    if (!bypassDeleteCheck && ncrActive === 2 && initialActive !== 2) {
      setPendingSubmit(true);
      deleteWarningRef.current?.showModal();
      return;
    }
    setIsSubmitLoading(true);
    setIsBlurred(true);

    console.log("dataSet", {
      ncrProjectName,
      ncrReportedBy,
      ncrReportedDate,
      ncrCustomerComplaint,
      ncrMadeVia,
      ncrType,
      ncrCustomer,
      ncrConcernReported: ncrReportedConcern,
      ncrCause,
      ncrStatus,
      ncrActive,
    });

    let ncrErrors = ncrFormValidator({
      ncrProjectName,
      ncrReportedBy,
      ncrReportedDate,
      ncrCustomerComplaint,
      ncrMadeVia,
      ncrType,
      ncrCustomer,
      ncrConcernReported: ncrReportedConcern,
      ncrCause,
      ncrStatus,
      ncrActive,
    });

    let ncrCustomErrors = {};
    let isError = false;
    //if ncrImmAction is not empty then all the immediate action fields are required
    if (ncrImmAction) {
      ncrCustomErrors = {
        ...ncrCustomErrors,
        ncrImmAction: ncrImmAction ? "" : "Immediate Action is required",
        ncrImmBy: ncrImmBy ? "" : "Immediate Action Taken By is required",
        ncrImmDate: ncrImmDate ? "" : "Immediate Action Taken Date is required",
      };

      if (
        ncrCustomErrors.ncrImmAction ||
        ncrCustomErrors.ncrImmBy ||
        ncrCustomErrors.ncrImmDate
      ) {
        isError = true;
      } else {
        isError = false;
      }
    }
    //if ncrCorrAction is not empty then all the corrective action fields are required
    if (ncrCorrAction) {
      ncrCustomErrors = {
        ...ncrCustomErrors,
        ncrCorrAction: ncrCorrAction ? "" : "Corrective Action is required",
        ncrCorrBy: ncrCorrBy ? "" : "Corrective Action Taken By is required",
        ncrCorrDate: ncrCorrDate
          ? ""
          : "Corrective Action Taken Date is required",
      };

      if (
        ncrCustomErrors.ncrCorrAction ||
        ncrCustomErrors.ncrCorrBy ||
        ncrCustomErrors.ncrCorrDate
      ) {
        isError = true;
      } else {
        isError = false;
      }
    }

    // if ncrPreAction is not empty then all the preventive action fields are required

    if (ncrPrvAction) {
      ncrCustomErrors = {
        ...ncrCustomErrors,
        ncrPreAction: ncrPrvAction ? "" : "Preventive Action is required",
        ncrPreBy: ncrPreBy ? "" : "Preventive Action Taken By is required",
        ncrPreDate: ncrPreDate
          ? ""
          : "Preventive Action Taken Date is required",
      };

      if (
        ncrCustomErrors.ncrPreAction ||
        ncrCustomErrors.ncrPreBy ||
        ncrCustomErrors.ncrPreDate
      ) {
        isError = true;
      } else {
        isError = false;
      }
    }

    let emailPhoneError = {};
    let isEmailPhoneError = false;

    if (ncrMadeVia === 2) {
      emailPhoneError = {
        ...emailPhoneError,
        ncrEmail: ncrEmail ? "" : "Email is required",
      };

      if (emailPhoneError.ncrEmail) {
        isEmailPhoneError = true;
      } else {
        isEmailPhoneError = false;
      }
    } else if (ncrMadeVia === 1) {
      emailPhoneError = {
        ...emailPhoneError,
        ncrPhone: ncrPhone ? "" : "Phone is required",
      };

      if (emailPhoneError.ncrPhone) {
        isEmailPhoneError = true;
      } else {
        isEmailPhoneError = false;
      }
    }
    if (isEmailPhoneError) {
      ncrErrors = { ...ncrErrors, ...emailPhoneError };
    }

    if (Object.keys(ncrErrors).length > 0 || isError) {
      if (Object.keys(ncrErrors).length > 0) {
        toast.error(
          "Please Fill the required fields in general information section",
          { autoClose: 5000, containerId: "Main" },
        );
      }

      if (isError) {
        toast.error(
          "Please check and fill the required fields in the immediate, corrective and preventive action sections",
          { autoClose: 5000, containerId: "Main" },
        );
      }
      ncrErrors = { ...ncrErrors, ...ncrCustomErrors };
      setCurrentErrors(ncrErrors);
      console.log("ncrErrors", ncrErrors);
      document.querySelector(".ui.form").classList.add("error");

      setIsSubmitLoading(false);
      setIsBlurred(false);
      return;
    } else {
      document.querySelector(".ui.form").classList.remove("error");
      setCurrentErrors({});
    }

    if (!editMode) {
      const data = {
        ncrCompany: company,
        ncrProjectName,
        ncrReportedBy,
        ncrReportedDate,
        ncrCustomerComplaint,
        ncrMadeVia,
        ncrType,
        ncrCustomer,
        ncrCustomerName: ncrCustomerName,
        ncrEmail,
        ncrPhone,
        ncrSeverity,
        ncrConcernReported: ncrReportedConcern,
        ncrCause,
        ncrImmAction,
        ncrImmBy,
        ncrImmDate,
        ncrCorrAction,
        ncrCorrBy,
        ncrCorrDate,
        ncrPreAction: ncrPrvAction,
        ncrPreBy,
        ncrPreDate,
        ncrFinalOutcome,
        ncrFeedbackGiven,
        ncrFeedbackReevaluation,
        ncrReevaluationDate,
        ncrSeq: 1,
        ncrStatus,
        ncrActive,
        ncrCost: parseFloat(ncrCost),
        ncrReqId: reqId,
        ncrReqCode: reqCode,
        author: user.username,
      };

      const response = await ncrUpload(data);

      const documents = documentRef.current.getData();
      setNcrId(response.data.ncrId);

      let hasUploadErrors = false;
      if (documents.length > 0) {
        for (let doc of documents) {
          const { file, ...rest } = doc;
          const formData = new FormData();
          formData.append("multipartFile", doc.file);
          formData.append(
            "documentRequest",
            JSON.stringify({
              ...rest,
              docReference: response.data.ncrId,
            }),
          );
          formData.append("isImage", rest.docCategory === 1);
          const res = await addAndUpload(formData);
          if (res && res?.responseCode === "2040") {
            toast.success(res?.message, {
              autoClose: 5000,
              containerId: "Main",
            });
          } else {
            hasUploadErrors = true;
            documentRef.current.markUploadFailed(doc.id ?? doc.fileName);
            toast.error(
              res?.message || `Error adding document ${doc.docName}`,
              {
                autoClose: 5000,
                containerId: "Main",
              },
            );
          }
        }
      }

      if (response.status === 200) {
        toast.success(response.data.ncrCode + " Created Successfully !", {
          autoClose: 5000,
          containerId: "Main",
        });

        if (hasUploadErrors) {
          setIsSubmitLoading(false);
          return;
        }

        resetForm();
        handleDrawerClose();
        // setUpdateNeeded(true);
      } else {
        toast.error("Failed to create NCR", {
          autoClose: 5000,
          containerId: "Main",
        });
      }
    } else {
      const data = {
        ncrCompany: company,
        ncrCode,
        ncrProjectName,
        ncrReportedBy,
        ncrReportedDate,
        ncrCustomerComplaint,
        ncrMadeVia,
        ncrType,
        ncrCustomer,
        ncrCustomerName: ncrCustomerName,
        ncrEmail,
        ncrPhone,
        ncrSeverity,
        ncrConcernReported: ncrReportedConcern,
        ncrCause,
        ncrImmAction,
        ncrImmBy,
        ncrImmDate,
        ncrCorrAction,
        ncrCorrBy,
        ncrCorrDate,
        ncrPreAction: ncrPrvAction,
        ncrPreBy,
        ncrPreDate,
        ncrFinalOutcome,
        ncrFeedbackGiven,
        ncrFeedbackReevaluation,
        ncrReevaluationDate,
        ncrSeq: 1,
        ncrStatus,
        ncrActive,
        ncrCost: parseFloat(ncrCost),
        ncrReqId: reqId,
        ncrReqCode: reqCode,
        author: user.username,
      };
      const response = await ncrUpdate(ncrid, data);

      const documents = documentRef.current.getData();
      let hasUploadErrors = false;
      for (let doc of documents.created) {
        const { file, ...rest } = doc;
        const formData = new FormData();
        formData.append("multipartFile", doc.file);
        formData.append("documentRequest", JSON.stringify(rest));
        formData.append("isImage", rest.docCategory === 1);
        const res = await addAndUpload(formData);
        if (res && res?.responseCode === "2040") {
          toast.success(res?.message, {
            autoClose: 5000,
            containerId: "Main",
          });
        } else {
          hasUploadErrors = true;
          documentRef.current.markUploadFailed(doc.id ?? doc.fileName);
          toast.error(res?.message || `Error adding document ${doc.docName}`, {
            autoClose: 5000,
            containerId: "Main",
          });
        }
      }

      for (let doc of documents.modified) {
        const { file, ...rest } = doc;
        const formData = new FormData();
        formData.append("multipartFile", doc.file);
        formData.append("documentRequest", JSON.stringify(rest));
        formData.append("isImage", rest.docCategory === 1);
        const res = await updateAndUpload(formData);
        if (res && res?.responseCode === "2040") {
          toast.success(res?.message, {
            autoClose: 5000,
            containerId: "Main",
          });
        } else {
          hasUploadErrors = true;
          documentRef.current.markUploadFailed(doc.id ?? doc.fileName);
          toast.error(
            res?.message || `Error updating document ${doc.docName}`,
            {
              autoClose: 5000,
              containerId: "Main",
            },
          );
        }
      }

      if (documents?.deleted.length > 0) {
        await deleteDocumentList({
          docIdList: documents?.deleted,
        });
        toast.success("Documents deleted successfully!", {
          autoClose: 5000,
          containerId: "Main",
        });
      }

      if (response.status === 200) {
        toast.success(ncrCode + " Updated Successfully !", {
          autoClose: 5000,
          containerId: "Main",
        });

        if (hasUploadErrors) {
          setIsSubmitLoading(false);
          return;
        }

        resetForm();
        handleDrawerClose();
        // setUpdateNeeded(true);
      } else {
        toast.error("Failed to update " + ncrCode, {
          autoClose: 5000,
          containerId: "Main",
        });
      }
    }

    setIsSubmitLoading(false);
    setIsBlurred(false);
  };

  const resetForm = () => {
    setNcrCompany("");
    setNcrProjectName("");
    setNcrReportedBy("");
    setNcrReportedDate("");
    setNcrCustomerComplaint("");
    setNcrMadeVia("");
    setNcrType("");
    setNcrCustomer("");
    setNcrCustomerName("");
    setNcrEmail("");
    setNcrPhone("");
    setNcrSeverity("");
    setNcrReportedConcern("");
    setNcrCause("");
    setNcrImmAction("");
    setNcrImmBy("");
    setNcrImmDate("");
    setNcrCorrAction("");
    setNcrCorrBy("");
    setNcrCorrDate("");
    setNcrPreAction("");
    setNcrPreBy("");
    setNcrPreDate("");
    setNcrFinalOutcome("");
    setNcrFeedbackGiven("");
    setNcrFeedbackReevaluation("");
    setNcrReevaluationDate("");
    setNcrStatus(2);
    setNcrActive(1);
    setSearchFieldReset(true);
  };

  return (
    <div>
      {isBlurred && (
        <div className="blur-overlay">
          {editMode ? (
            <LoadingSpinner message={`Updating ${ncrCode}...`} />
          ) : (
            <LoadingSpinner message={`Creating NCR...`} />
          )}
        </div>
      )}
      <div className="ui tabular menu top attached">
        <Tab
          Icon={Info}
          onClick={() => {
            setTab(firstViableTab);
          }}
          active={tab === 1}
          label="General Info"
          authenticated={true}
          module={MODULES.Transaction}
          form={FORMS.NCR.GENERAL.form}
        />
        <Tab
          Icon={Upload}
          onClick={() => {
            setTab(2);
          }}
          active={tab === 2}
          label="Document Upload"
          authenticated={true}
          module={MODULES.Transaction}
          form={FORMS.NCR.DOCUMENT.form}
        />
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        {isDropdownLoading || infoLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div className="ui form">
              <div className="ui segment">
                <div className="ui dividing header">General Information</div>
                <div className="three fields">
                  <Input
                    required={true}
                    type="text"
                    label="Project Name"
                    name="projectName"
                    placeholder="Project Name"
                    value={ncrProjectName}
                    onChange={(e) => setNcrProjectName(e.target.value)}
                    error={currentErrors.ncrProjectName}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrProjectName: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Input
                    required={true}
                    type="text"
                    label="Reported By"
                    name="reportedBy"
                    placeholder="Reported By"
                    value={ncrReportedBy}
                    onChange={(e) => setNcrReportedBy(e.target.value)}
                    error={currentErrors.ncrReportedBy}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrReportedBy: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Input
                    required={true}
                    type="date"
                    label="Reported Date"
                    name="reportedDate"
                    placeholder="Reported Date"
                    value={ncrReportedDate}
                    onChange={(e) => setNcrReportedDate(e.target.value)}
                    error={currentErrors.ncrReportedDate}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrReportedDate: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    min={
                      editMode
                        ? ncrReportedDate
                        : new Date().toISOString().split("T")[0]
                    }
                  />
                </div>
                <div className="four fields">
                  <Dropdown
                    required={true}
                    label="Customer Complaint"
                    name="customerComplaint"
                    placeholder="Customer Complaint"
                    options={customerComplaintOptions}
                    value={ncrCustomerComplaint}
                    onChange={(e, data) => setNcrCustomerComplaint(data.value)}
                    error={currentErrors.ncrCustomerComplaint}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrCustomerComplaint: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Dropdown
                    required={true}
                    label="NCR Made via"
                    name="madeVia"
                    placeholder="Made via"
                    options={madeViaOptions}
                    value={ncrMadeVia}
                    onChange={(e, data) => setNcrMadeVia(data.value)}
                    error={currentErrors.ncrMadeVia}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrMadeVia: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Dropdown
                    required={true}
                    label="NCR Type"
                    name="ncrType"
                    placeholder="NCR Type"
                    options={ncrTypeOptions}
                    value={ncrType}
                    onChange={(e, data) => setNcrType(data.value)}
                    error={currentErrors.ncrType}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrType: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <SearchDropdown
                    required={true}
                    key={1}
                    label={"Customer"}
                    clearable={true}
                    onClear={() => setNcrCustomer("")}
                    editMode={editMode}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    onResultSelect={(data) => setNcrCustomer(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Customer",
                    }}
                    fieldInfo={{
                      tableName: "masterdata.tms_m_stakeholder",
                      primaryKey: "stk_id",
                      fieldName: "stk_name",
                      id: ncrCustomer,
                    }}
                    error={currentErrors.ncrCustomer}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrCustomer: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                </div>
                <div className="four fields">
                  <Input
                    required={ncrMadeVia === 2 ? true : false}
                    type="email"
                    name="email"
                    placeholder="Email"
                    label="Email"
                    value={ncrEmail}
                    onChange={(e) => setNcrEmail(e.target.value)}
                    error={currentErrors.ncrEmail}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrEmail: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Input
                    required={ncrMadeVia === 1 ? true : false}
                    type="text"
                    name="phone"
                    placeholder="Phone"
                    label="Phone"
                    value={ncrPhone}
                    onChange={(e) => setNcrPhone(e.target.value)}
                    error={currentErrors.ncrPhone}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrPhone: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Dropdown
                    label="Severity"
                    name="severity"
                    placeholder="Severity"
                    options={ncrTypeOptions}
                    value={ncrSeverity}
                    onChange={(e, data) => setNcrSeverity(data.value)}
                  />
                  <Input
                    required={true}
                    type="text"
                    label="Reported Concern"
                    name="reportedConcern"
                    placeholder="Reported Concern"
                    value={ncrReportedConcern}
                    onChange={(e) => setNcrReportedConcern(e.target.value)}
                    error={currentErrors.ncrConcernReported}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrConcernReported: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                </div>
                <div className="four fields">
                  <Input
                    required={true}
                    type="text"
                    label="Cause"
                    name="cause"
                    placeholder="Cause"
                    value={ncrCause}
                    onChange={(e) => setNcrCause(e.target.value)}
                    error={currentErrors.ncrCause}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrCause: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Input
                    type="text"
                    label="Ncr Cost"
                    name="ncrCost"
                    placeholder="Ncr Cost"
                    value={ncrCost}
                    onChange={(e) => setNcrCost(e.target.value)}
                  />

                  <Dropdown
                    required={true}
                    label="Status"
                    placeholder="Select Status"
                    options={statusOptions}
                    value={ncrStatus}
                    onChange={(e, data) => setNcrStatus(data.value)}
                    error={currentErrors.ncrStatus}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrStatus: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Dropdown
                    required={true}
                    label="Active"
                    placeholder="Select Active"
                    options={activeOptions}
                    value={ncrActive}
                    onChange={(e, data) => setNcrActive(data.value)}
                    error={currentErrors.ncrActive}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrActive: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                </div>
              </div>
              <div className="ui segment">
                <div className="ui dividing header">Immediate Action Taken</div>
                <div className="three fields">
                  <Input
                    required={ncrImmAction ? true : false}
                    type="text"
                    label="Immediate Action"
                    name="action"
                    placeholder="Action"
                    value={ncrImmAction}
                    onChange={(e) => setNcrImmAction(e.target.value)}
                    error={currentErrors.ncrImmAction}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrImmAction: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Input
                    required={ncrImmAction ? true : false}
                    type="text"
                    label="Immediate Action Taken By"
                    name="takenBy"
                    placeholder="Taken By"
                    value={ncrImmBy}
                    onChange={(e) => setNcrImmBy(e.target.value)}
                    error={currentErrors.ncrImmBy}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrImmBy: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Input
                    required={ncrImmAction ? true : false}
                    type="date"
                    label="Immediate Action Taken Date"
                    name="takenDate"
                    placeholder="Taken Date"
                    value={ncrImmDate}
                    onChange={(e) => setNcrImmDate(e.target.value)}
                    error={currentErrors.ncrImmDate}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrImmDate: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                </div>
              </div>
              <div className="ui segment">
                <div className="ui dividing header">Corrective Action</div>
                <div className="three fields">
                  <Input
                    required={ncrCorrAction ? true : false}
                    type="text"
                    label="Corrective Action"
                    name="action"
                    placeholder="Action"
                    value={ncrCorrAction}
                    onChange={(e) => setNcrCorrAction(e.target.value)}
                    error={currentErrors.ncrCorrAction}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrCorrAction: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Input
                    required={ncrCorrAction ? true : false}
                    type="text"
                    label="Corrective Action Taken By"
                    name="takenBy"
                    placeholder="Taken By"
                    value={ncrCorrBy}
                    onChange={(e) => setNcrCorrBy(e.target.value)}
                    error={currentErrors.ncrCorrBy}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrCorrBy: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Input
                    required={ncrCorrAction ? true : false}
                    type="date"
                    label="Corrective Action Taken Date"
                    name="takenDate"
                    placeholder="Taken Date"
                    value={ncrCorrDate}
                    onChange={(e) => setNcrCorrDate(e.target.value)}
                    error={currentErrors.ncrCorrDate}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrCorrDate: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                </div>
              </div>
              <div className="ui segment">
                <div className="ui dividing header">Preventive Action</div>
                <div className="three fields">
                  <Input
                    required={ncrPrvAction ? true : false}
                    type="text"
                    label="Preventive Action"
                    name="action"
                    placeholder="Action"
                    value={ncrPrvAction}
                    onChange={(e) => setNcrPreAction(e.target.value)}
                    error={currentErrors.ncrPreAction}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrPreAction: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Input
                    required={ncrPrvAction ? true : false}
                    type="text"
                    label="Preventive Action Taken By"
                    name="takenBy"
                    placeholder="Taken By"
                    value={ncrPreBy}
                    onChange={(e) => setNcrPreBy(e.target.value)}
                    error={currentErrors.ncrPreBy}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrPreBy: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Input
                    required={ncrPrvAction ? true : false}
                    type="date"
                    label="Preventive Action Taken Date"
                    name="takenDate"
                    placeholder="Taken Date"
                    value={ncrPreDate}
                    onChange={(e) => setNcrPreDate(e.target.value)}
                    error={currentErrors.ncrPreDate}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrPreDate: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                </div>
              </div>
              <div className="ui segment">
                <div className="ui dividing header">Final Details</div>
                <div className="four fields">
                  <Input
                    type="text"
                    label="Final Outcome"
                    name="finalOutcome"
                    placeholder="Final Outcome"
                    value={ncrFinalOutcome}
                    onChange={(e) => setNcrFinalOutcome(e.target.value)}
                    error={currentErrors.ncrFinalOutcome}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrFinalOutcome: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Input
                    type="text"
                    label="Given Feedback"
                    name="givenFeedback"
                    placeholder="Given Feedback"
                    value={ncrFeedbackGiven}
                    onChange={(e) => setNcrFeedbackGiven(e.target.value)}
                    error={currentErrors.ncrFeedbackGiven}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrFeedbackGiven: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Input
                    type="text"
                    label="Feedback Re-evaluation"
                    name="feedbackReevaluation"
                    placeholder="Feedback Re-evaluation"
                    value={ncrFeedbackReevaluation}
                    onChange={(e) => setNcrFeedbackReevaluation(e.target.value)}
                    error={currentErrors.ncrFeedbackReevaluation}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrFeedbackReevaluation: _, ...rest } =
                          prevState;
                        return rest;
                      })
                    }
                  />
                  <Input
                    type="date"
                    label="Re-evaluation Date"
                    name="reevaluationDate"
                    placeholder="Re-evaluation Date"
                    value={ncrReevaluationDate}
                    onChange={(e) => setNcrReevaluationDate(e.target.value)}
                    error={currentErrors.ncrReevaluationDate}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { ncrReevaluationDate: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                </div>
              </div>
            </div>
            {editMode && (
              <InfoList
                title="User Information"
                content={[
                  {
                    title: "Created By",
                    value: auditInfo.createdBy ? auditInfo.createdBy : "N/A",
                  },
                  {
                    title: "Created Date",
                    value: auditInfo.createdDate
                      ? formatFromJsonDate(auditInfo.createdDate)
                      : "N/A",
                  },
                  {
                    title: "Last Modified By",
                    value: auditInfo.lastModifiedBy
                      ? auditInfo.lastModifiedBy
                      : "N/A",
                  },
                  {
                    title: "Last Modified Date",
                    value: auditInfo.lastModifiedDate
                      ? formatFromJsonDate(auditInfo.lastModifiedDate)
                      : "N/A",
                  },
                ]}
                Icon={User}
              />
            )}
          </>
        )}
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 2 ? "block" : "none" }}
      >
        <DocumentUpload
          isLoading={isDropdownLoading}
          opeType={12}
          ref={documentRef}
          module={MODULES.Transaction}
          reference={ncrid}
          dropdown={{
            documentTypeOptions: documentTypeOptions,
            statusOptions: statusOptions,
            fileNameOptions: fileNameOptions,
            activeOptions: activeOptions,
          }}
          editMode={editMode}
          currentValues={editMode && documents !== null ? documents : null}
        />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          justifyContent: "flex-end",
        }}
      >
        <Button
          template="create"
          isLoading={isSubmitLoading}
          create={!editMode}
          editMode={editMode}
          onClick={() => submitNcr()}
          form={FORMS.NCR.GENERAL.form}
          module={MODULES.Transaction}
          authenticated={true}
        />
      </div>
      <Modal ref={deleteWarningRef} closeButton={false} minWidth={"300px"}>
        {showDeleteWarning || pendingSubmit ? (
          <div style={{ padding: "20px" }}>
            <h3 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <AlertCircle color="red" size="25" />
              <p>Warning</p>
            </h3>
            <p>Active is set to Deleted. Are you sure you want to proceed?</p>
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "flex-end",
              }}
            >
              <Button
                label="Cancel"
                onClick={() => {
                  deleteWarningRef.current?.close();
                  setPendingSubmit(false);
                }}
              />
              <Button
                label="Proceed"
                className="ui red button"
                onClick={() => {
                  deleteWarningRef.current?.close();
                  setPendingSubmit(false);
                  setInitialActive(2);
                  submitNcr(true);
                }}
              />
            </div>
          </div>
        ) : null}
      </Modal>
    </div>
  );
};

export default NCRCreate;

const styles = `
  .blur-overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    z-index: 9999; /* Ensure it's on top of everything */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .blurred {
    filter: blur(5px); /* Blur effect on content */
    pointer-events: none; /* Prevent interaction with blurred content */
  }
`;

document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);
